import { useState, useEffect } from 'react';

const MOBILE_MAX_WIDTH = 600;
const TABLET_MAX_WIDTH = 900;

export const useDeviceDetect = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [isRealMobile, setIsRealMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isRealTab, setIsRealTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth, innerHeight } = window;
      const userAgent = navigator.userAgent.toLowerCase();
      setIsRealTablet(
        /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent));
      setIsRealMobile(
        /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent));

      // Vérifier la taille de l'écran pour déterminer le type d'appareil (portait & landscape)
      setIsLandscape(innerWidth > innerHeight);
      setIsTablet(false);
      setIsMobile(
        isLandscape
          ? innerHeight <= MOBILE_MAX_WIDTH
          : innerWidth <= MOBILE_MAX_WIDTH,
      );

      if (innerWidth > MOBILE_MAX_WIDTH && innerWidth <= TABLET_MAX_WIDTH)
        setIsTablet(true);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Appeler handleResize une fois au montage initial

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isLandscape, isMobile, isTablet, isRealTab, isRealMobile]);

  return { isMobile, isLandscape, isTablet, isRealTab, isRealMobile };
};

export default useDeviceDetect;
